import type { ID } from '@/types/common';

export function calculateSourceCount(
    filteredItems: ReadonlyArray<{ event: { sourceId: ID } }>,
    eventsResult: { totalItems: number; pageSize: number },
    sourceId?: string,
): number | undefined {
    if (sourceId) return 1;
    if (eventsResult.totalItems <= eventsResult.pageSize) {
        return new Set(filteredItems.map((item) => item.event.sourceId)).size;
    }
    return undefined;
}
